// extracted by mini-css-extract-plugin
export default {"App":"range_App__i-fFb","range":"range_range__3YtR3","skill":"range_skill__feu4u","other":"range_other__CiPUz","head":"range_head__xXHW2"};